import { render, staticRenderFns } from "./BulkCreateAppraisals.vue?vue&type=template&id=6d4e037c&scoped=true&"
import script from "./BulkCreateAppraisals.vue?vue&type=script&lang=ts&"
export * from "./BulkCreateAppraisals.vue?vue&type=script&lang=ts&"
import style0 from "./BulkCreateAppraisals.vue?vue&type=style&index=0&id=6d4e037c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4e037c",
  null
  
)

export default component.exports